<template>
  <v-layout class="empty-state" align-center justify-center column fill-height>
    <img
      :src="imageSrc"
      :alt="text"
      class="mb-4"
      :style="imageSize > 0 ? `width: ${imageSize}px` : null"
    >
    <p v-if="text" v-html="text" class="text-xs-center px-2 mb-0" />
    <slot></slot>
  </v-layout>
</template>

<script>
import rides from 'images/img-empty-state-rides.svg'
import costCenter from 'images/img-empty-state-c-custo.svg'
import employee from 'images/img-empty-state-colab.svg'
import usagePolicy from 'images/img-empty-state-usage-policy.svg'
import phone from 'images/img-empty-phone.svg'

export default {
  name: 'EmptyState',
  props: {
    image: {
      type: String,
      default: rides
    },
    text: {
      type: String,
      default: null
    },
    imageSize: {
      type: [Number, String],
      default: 0
    }
  },
  data () {
    return {
      imageSrc: null
    }
  },
  methods: {
    renderHtml () {
      switch (this.image) {
        case 'rides':
          this.imageSrc = rides
          return

        case 'cost-center':
          this.imageSrc = costCenter
          return

        case 'employee':
          this.imageSrc = employee
          return

        case 'usage-policy':
          this.imageSrc = usagePolicy
          return

        case 'phone':
          this.imageSrc = phone
          return

        default:
          this.imageSrc = rides
      }
    }
  },
  watch: {
    image () {
      this.renderHtml()
    },
    text () {
      this.renderHtml()
    },
    imageSize () {
      this.renderHtml()
    }
  },
  mounted () {
    this.renderHtml()
  }
}
</script>

<style lang="scss">
.state__text {
  font-size: 12px;
  text-align: center;

  p {
    color: $gray-6;
  }
}
</style>
